module.exports = __webpack_public_path__ + "img/wrong.2087ddde.png";